module.exports = __webpack_public_path__ + "img/utui.64043e9f.jpg";